import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import "../pd-markdown-view.js";
import { LitElement, css, html, nothing } from "lit";
import { property } from "lit/decorators.js";
import { localized, msg, str } from "@lit/localize";
import { formatShortDate, formatToTime } from "@progressive-development/pd-utils";
//#region src/pd-chat/PdChatItem.ts
/**
* @license
* Copyright (c) 2026 PD Progressive Development UG. All rights reserved.
*/
var PdChatItem = class PdChatItem extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.own = false;
		this.grouped = false;
	}
	static {
		this.styles = css`
    :host {
      display: block;
      /* Flex-Kind der Spalte in pd-chat-list: align-self ersetzt jede
         Einrückung, max-width begrenzt die Blase. */
      align-self: flex-start;
      max-width: var(--pd-chat-bubble-max-width, 85%);
      min-width: 0;
    }

    :host([own]) {
      align-self: flex-end;
    }

    .bubble {
      /* min-width: 0 lässt breite Markdown-Blöcke (pre, table) INNEN
         scrollen, statt die Blase aufzuweiten. */
      min-width: 0;
      padding: 0.6rem 0.85rem;
      background: var(
        --pd-chat-bubble-bg-col,
        var(--pd-default-bg-light-col, #f0f0f0)
      );
      color: var(--pd-default-font-content-col, #333);
      overflow-wrap: anywhere;
      /* Zur Sprechrichtung zeigende Ecke abgeflacht — Zipfel-Wirkung
         ohne Zipfel-Geometrie. */
      border-radius: var(--pd-chat-bubble-radius, var(--pd-radius-md, 0.5rem));
      border-bottom-left-radius: 2px;
    }

    :host([own]) .bubble {
      background: var(
        --pd-chat-bubble-own-bg-col,
        var(--pd-default-light-col, #e0e0e0)
      );
      border-bottom-left-radius: var(
        --pd-chat-bubble-radius,
        var(--pd-radius-md, 0.5rem)
      );
      border-bottom-right-radius: 2px;
    }

    .meta {
      margin-top: 0.2rem;
      font-size: var(--pd-chat-meta-font-size, 0.8em);
      color: var(--pd-default-font-muted-col, #757575);
    }

    :host([own]) .meta {
      text-align: right;
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip-path: inset(50%);
      white-space: nowrap;
      border: 0;
    }
  `;
	}
	render() {
		const entry = this.entry;
		if (!entry) return nothing;
		const time = formatToTime(entry.at);
		return html`
      <div class="bubble" part="bubble">
        <span class="sr-only">${this._screenReaderPrefix(entry, time)}</span>
        <pd-markdown-view .markdown="${entry.text}"></pd-markdown-view>
      </div>
      <div class="meta" part="meta" aria-hidden="true">
        ${this.own || this.grouped ? nothing : html`<span class="name">${entry.actorLabel}</span> · `}
        <time datetime="${entry.at}" title="${formatShortDate(entry.at, true)}">
          ${time}
        </time>
      </div>
    `;
	}
	/** Voller Kontext für Screenreader — auch bei `grouped`, wo der Name
	*  visuell fehlt. Die Links/Rechts-Unterscheidung trägt dort nichts. */
	_screenReaderPrefix(entry, time) {
		return this.own ? msg(str`Ich, ${time}:`, { id: "pd.chat.item.srOwn" }) : msg(str`${entry.actorLabel}, ${time}:`, { id: "pd.chat.item.srOther" });
	}
};
__decorate([property({ attribute: false })], PdChatItem.prototype, "entry", void 0);
__decorate([property({
	type: Boolean,
	reflect: true
})], PdChatItem.prototype, "own", void 0);
__decorate([property({
	type: Boolean,
	reflect: true
})], PdChatItem.prototype, "grouped", void 0);
PdChatItem = __decorate([localized()], PdChatItem);
//#endregion
export { PdChatItem };
